function Services() {
  return (
    <div className="services-page">
      <section className="services-hero">
        <h1>Our Organic Services</h1>
        <p>
          Fresh organic fruits and vegetables
          with reliable delivery and healthy
          food solutions for families and
          businesses.
        </p>
      </section>

      <section className="services-section">
        <div className="services-grid">
          <div className="service-card">

            <img
              src="https://images.unsplash.com/photo-1520607162513-77705c0f0d4a"
              alt="Home Delivery"/>

            <div className="service-content">
              <h3>🚚 Home Delivery</h3>
              <p>
                Farm fresh vegetables and fruits
                delivered directly to your
                doorstep every day.
              </p>
            </div>
          </div>

          <div className="service-card">
            <img
              src="https://images.unsplash.com/photo-1506617564039-2f3b650b7010"
              alt="Bulk Orders"
            />

            <div className="service-content">
              <h3>🥬 Bulk Orders</h3>
              <p>
                Organic supplies for hotels,
                restaurants, cafes, and local
                businesses at wholesale prices.
              </p>
            </div>
          </div>

          <div className="service-card">
            <img
              src="https://images.unsplash.com/photo-1464226184884-fa280b87c399"
              alt="Farm Pickup"
            />

            <div className="service-content">
              <h3>🚜 Farm Pickup</h3>
              <p>
                Visit our farms and directly
                collect fresh harvested organic
                products.
              </p>
            </div>
          </div>


          <div className="service-card">
            <img
              src="https://images.unsplash.com/photo-1518843875459-f738682238a6"
              alt="Custom Box"
            />

            <div className="service-content">
              <h3>🥗 Custom Organic Boxes</h3>
              <p>
                Create your own fruit and
                vegetable boxes according to
                your family needs.
              </p>

            </div>

          </div>

          <div className="service-card">
            <img
              src="https://images.unsplash.com/photo-1498837167922-ddd27525d352"
              alt="Fast Delivery"
            />

            <div className="service-content">
              <h3>⚡ Same Day Delivery</h3>
              <p>
                Quick and reliable same-day
                delivery service in nearby areas.
              </p>
            </div>
          </div>
        </div>
      </section>


      <section className="services-extra">
        <div className="extra-content">
          <h2>
            Healthy Food Delivered
            Fresh Everyday
          </h2>

          <p>
            AGP India Organic focuses on quality,
            freshness, and healthy organic living
            with trusted farm partnerships.
          </p>
        </div>
        <img
          src="https://images.unsplash.com/photo-1490818387583-1baba5e638af"
          alt="Organic Food"
        />
      </section>
    </div>
  );
}

export default Services;